import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

export default function FinalCTA() {
  return (
    <section className="relative py-28 md:py-36 bg-[#f7f3ea]">
      <div
        className="absolute inset-0 pointer-events-none opacity-60"
        style={{
          background:
            "radial-gradient(700px 400px at 50% 50%, rgba(72,106,143,0.15), transparent 70%)",
        }}
      />
      <div className="relative max-w-3xl mx-auto px-6 text-center">
        <Reveal>
          <h2 className="font-display text-[36px] sm:text-[44px] md:text-[64px] leading-[1.05] text-[#0f1724] tracking-tight">
            Your next right step is{" "}
            <span className="italic font-light text-[#486a8f]">one conversation away.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="font-body mt-6 text-[16px] md:text-[19px] text-[#4b5563] leading-relaxed">
            You don't have to figure it all out today. Talk to a mentor who listens, helps you get unstuck, and tells you what to do next.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10">
            <Link to="/start" data-testid="finalcta-start-trial-btn">
              <Button className="group h-14 px-8 rounded-full bg-[#486a8f] hover:bg-[#3a5a7c] text-white font-medium text-[15px] btn-lift">
                Start My 3-Day Trial
                <ArrowRight
                  size={17}
                  className="ml-2 transition-transform duration-300 group-hover:translate-x-1"
                />
              </Button>
            </Link>
            <p className="font-body text-[13px] text-[#6b7280] mt-4">
              Free 3-day trial · Card required · Cancel anytime · Secure by Stripe
            </p>
            <p className="font-body text-[11px] text-[#9aa3ae] mt-2 max-w-md mx-auto leading-relaxed">
              Not therapy. Not crisis support. Practical AI mentorship.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
